/**
 * 接口文档：
 * http://apidoc.bangong.knowbox.cn/gaoyx/mobile/meeting/#api-mobile-meeting
 * http://apidoc.bangong.knowbox.cn/gaoyx/teacher/jubao/#api-user-user-jubao
 * http://apidoc.bangong.knowbox.cn/gaoyx/privacy/info/#api-common-get-privacy-info
 * http://apidoc.bangong.knowbox.cn/gaoyx/listen/course/#api-listen-course
 */

const API = {
  getQiniuToken: "/teacher/user/get-qiniu-token", // 获取七牛云token
  getQiniuTokenNew: "/teacher/user-new/get-qiniu-token", // 获取七牛云token
  userJubao: "/teacher/user-new/user-jubao", // 用户举报接口
  getPrivacyInfo: "/html5/common/get-privacy-info", // 隐私政策详情
  // user
  weChatLogin: "/wechat/teacher/login-by-code", // 小盒老师授权登录
  verifyGet: "/verify/get", // 请求验证码图片（新-图形验证码）
  // smsValidCode: "/wechat/teacher/send-sms-code", // 发送验证码
  smsValidCode: "/wechat/teacher/send-sms-code-verify", // 发送验证码（新-图形验证码）
  // bindingWeChat: "/wechat/teacher/sms-code-bind", // 小盒老师绑定
  bindingWeChat: "/wechat/teacher/sms-code-bind-verify", // 小盒老师绑定（新-图形验证码）
  // bindingLogin: "/wechat/teacher/sms-code-login", // 浏览器登录绑定
  bindingLogin: "/wechat/teacher/sms-code-login-verify", // 浏览器登录绑定（新-图形验证码）
  loginOut: "/wechat/teacher/logout", // 退出登录
  teacherInfo: "/wechat/teacher/info", // 小盒老师信息
  // weChatLogin: "/user/center/wechat/weChatLogin.do", // 微信code登录
  // checkImageCodeV3: "/user/center/checkImageCodeV3.do", // 判断手机号是否需要验证码
  // imageCode: "/user/center/imageCode.do", // 获取图形验证码
  // smsValidCode: "/user/center/smsValidCode.do", // 发送短信验证码
  // bindingWeChat: "/user/center/wechat/bindingWeChat.do", // 手机号登录并绑定微信
  getUserInfo: "/user/center/info.do", // 获取用户信息
  infoComplete: "/wechat/teacher/info-complete", // 保存完善信息
  modifyPersonalSet: "/wechat/teacher/personal-setting", // 修改信息
  REGISTER_GET_CITY: "/html5/xueqing/city-version", // 注册页面请求城市和市区信息
  REGISTER_GET_PC_CITY_SCHOOL: "/teacher/app/get-pc-city-school", // 根据区id得到学校列表
  // 研修
  GET_INDEX: `/teacher/mobile-meeting/index`, // 研修首页
  GET_SEARCH_TAB: `/teacher/mobile-meeting/search-tab`, // 搜索结果页tabs接口
  GET_SEARCH_LIST: `/teacher/mobile-meeting/search-list`, // 搜索列表接口
  GET_EXCLUSIVE_INFO: `/teacher/mobile-meeting/exclusive-info`, // 首页本地研修
  GET_STUDY_LIST: `/teacher/mobile-meeting/study-list`, // 我的学习
  GET_CERT_LIST: `/teacher/mobile-meeting/cert-list`, // 我的证书
  GET_CERT_INFO: `/teacher/mobile-meeting/custom-cert-info`, // 证书详情
  GET_MORE_EXCLUSIVE: `/teacher/mobile-meeting/more-exclusive`, // 本地研修更多
  GET_MORE_PLATFORM: `/teacher/mobile-meeting/more-platform`, // 平台课程更多
  GET_COMMON_SUBJECT_LIST: `/teacher/meeting/common-subject-list`, // 公共学科
  GET_SPEAKER_LIST: `/teacher/mobile-meeting/speaker-list`, // 名师专区
  GET_PACHAGE_INFO: `/teacher/mobile-meeting/package-info`, // 课包详情页
  GET_PACKAGE_SIGN_UP: `/teacher/mobile-meeting/package-sign-up`, // 课包报名
  GET_MORE_GOING: `/teacher/mobile-meeting/more-going`, // 更多直播
  GET_SPEAKER_INFO: `/teacher/mobile-meeting/speaker-info`, // 名师主页
  GET_FILTER_AREA_LIST: `/teacher/mobile-meeting/filter-area-list`, // 区域筛选列表
  GET_VIEW_CERT: `/teacher/mobile-meeting/view-cert`, // 取消证书new
  GET_CREATE_CERT: `/teacher/mobile-meeting/create-cert`, // 手动生成证书
  GET_ADD_CLASS_HOUR_TWO_MINUTE: `/teacher/mobile-meeting/add-class-hour-two-minute`, // 两分钟请求一次增加学时
  POLLING: "/teacher/mobile-meeting/mobile-open-class",
  ADDPV: "/teacher/mobile-meeting/add-pv", // 增加pv
  ADDPVNOLOGIN: "/teacher/mobile-meeting/no-login-add-pv", // 增加pv
  AddOrUpdataNotice: "/teacher/meeting/add-or-update-notice",
  NOLOGIN_GET_PACHAGE_INFO: `/teacher/mobile-meeting/no-login-package-info`, // 课包详情页
  NOLOGIN_POLLING: "/teacher/mobile-meeting/no-login-open-class",
  NOLOGIN_GET_ADD_CLASS_HOUR_TWO_MINUTE: `/teacher/mobile-meeting/no-login-two-minute`, // 两分钟请求一次增加学时
  PACKAGE_CLASSHOURLIST: "/teacher/mobile-meeting/package-class-hour-list", // 学时记录列表
  SPEAKERLIST: "/teacher/mobile-meeting/get-speaker-list", // 课节老师信息
  COURSE_STUDY_PERCENT: "/teacher/pc-meeting/course-study-percent", // 课程学习进度
  // 听评课接口
  GET_SCHOOL_PROVINCE: "/html5/meeting/get-province-list", //查看所有省份
  GET_SCHOOL_CITY: "/html5/meeting/get-city-list", //查看某个省下面的市
  GET_SCHOOL_COUNTRY: "/html5/meeting/get-country-list", //查看某个市下面的区
  GET_SCHOOL_LIST: "/html5/meeting/get-school-list", // 搜索学校
  POSTER_DETAIL: "/html5/meeting/user-poster-detail", // 获取用户的海报详情
  SIGN_LE_LESSON: "/html5/meeting/sign-up-meeting", // 报名听评课后结果
  GET_LISTEN_COURSE_LIST: "/teacher/listen-course/course-list", // 听评课列表
  /**
   * 听评课课程详情相关start
   */
  GET_LISTEN_COURSE_DETAIL: "/teacher/listen-course/course-detail", // 听评课详情
  GET_COURSE_NOTICE_LIST: "/teacher/listen-course/course-notice-list", // 课程的笔记列表
  GET_COMMON_WORD_LIST: "/teacher/listen-course/common-word-list", // 常用语列表
  POST_ADD_COMMON_WORD: "/teacher/listen-course/add-common-word", // 添加常用语
  POST_UPDATE_COMMON_WORD: "/teacher/listen-course/update-common-word", // 修改常用语
  POST_DELETE_COMMON_WORD: "/teacher/listen-course/delete-common-word", // 删除常用语
  POST_ADD_COURSE_NOTICE: "/teacher/listen-course/add-course-notice", // 添加课程笔记
  POST_DELETE_COURSE_NOTICE: "/teacher/listen-course/delete-course-notice", // 删除课程笔记
  POST_UPDATE_COURSE_NOTICE: "/teacher/listen-course/update-course-notice", // 修改课程笔记文本
  POST_ADD_COURSE_ATTACH: "/teacher/listen-course/add-course-attach", // 添加课程笔记的附件
  POST_DELETE_COURSE_ATTACH: "/teacher/listen-course/delete-course-attach", // 删除课程笔记的附件
  POST_ADD_COURSE_CAPTURE: "/teacher/listen-course/add-course-capture", // 添加视频截取
  LISTEN_COURSE_HAS_POP: "/teacher/listen-course/has-pop", // 直播课结束或者回放课结束是否已经弹窗
  /**
   * end
   */
  GET_MY_COURSE_RESULT: "/teacher/listen-course/my-course-result", // 我的听评课成绩
  POST_MY_SCORE_RESULT: "/teacher/listen-course/my-score-result", // 老师对课程的打分结果
  POST_SCORE_COURSE: "/teacher/listen-course/score-course", // 老师对课程维度打分
  GET_MY_SCORE_DETAIL: "/teacher/listen-course/my-score-detail", // 老师待打分课程的打分信息
  GET_CURRENT_TIME: "/teacher/listen-course/get-current-time", // 获取当前时间
  GET_OPEN_LINK_WX: "/html5/meeting/get-open-link", // 跳转小程序链接

  GET_TAG_LIST: "/teacher/listen-course/get-tag-list", // 根据打分获取标签
  GET_DIM_SCORE_TEXT: "/teacher/listen-course/dim-score-text", // 生成维度的评语
  GET_CONCISE_TEXT: "/teacher/listen-course/concise-text", // 简评生成
  LISTEN_COURSE_EXPORT_FILE: "/teacher/listen-course/export-file", // 邮件导出文件
  POST_USER_STAGE: "/teacher/listen-course/user-stage", // 用户评课所处阶段

  // 运营活动
  FINISH_WATCH_COURSE: "/html5/act/finish-watch-course", // 观看教研会视频完成上报
  HOLIDAY_CHECK_TASK_TYPE: "/html5/act/check-task-type", // 查看对应活动任务完成情况
  GET_OPEN_LINK: "/html5/meeting/get-open-link", // 获取scheme码

  MINI_CHECK_ACTIVITY: "/html5/mini-act/check-activity", //检查任务有效性
};

export default API;
